import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 100px;
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
`;